import { Box } from '@mui/material';
import AdminLayout from '../../components/admin/AdminLayout';
import BotelManagement from '../../components/admin/BotelManagement';

const BotelManagementPage = () => {
  return (
    <AdminLayout>
      <Box sx={{ flexGrow: 1, p: { xs: 1, sm: 2, md: 3 }, background: '#151A23', minHeight: '100vh', color: '#fff', marginTop: 2 }}>
        <BotelManagement />
      </Box>
    </AdminLayout>
  );
};

export default BotelManagementPage; 